import { PALETTE } from '../StageData';
import { ShadingPipeline } from '../../engine/ShadingPipeline';
import type { ShapeDrawFn } from './furnitureShapes';

export const fashionDrawFns: Record<number, ShapeDrawFn> = {
  // STAGE 81: ハイテクスニーカー
  81: (ctx, cx, cy, mode) => {
    const drawSneaker = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 150, cy + 30);
      ctx.lineTo(cx - 140, cy - 50);
      ctx.bezierCurveTo(cx - 100, cy - 70, cx - 40, cy - 20, cx + 50, cy - 10);
      ctx.bezierCurveTo(cx + 120, cy - 10, cx + 150, cy + 30, cx + 150, cy + 50);
      ctx.lineTo(cx - 150, cy + 50);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawSneaker(); ctx.fill();
      ctx.fillRect(cx - 155, cy + 50, 310, 30);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawSneaker(); ctx.stroke();
        ctx.strokeRect(cx - 155, cy + 50, 310, 30);
        ctx.beginPath(); ctx.moveTo(cx - 60, cy + 10); ctx.quadraticCurveTo(cx, cy + 35, cx + 80, cy + 5); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 300, 100, PALETTE.purple, 'cloth');
      drawSneaker(); ctx.fill();
      ctx.fillStyle = PALETTE.white; ctx.fillRect(cx - 155, cy + 50, 310, 30);
      ctx.strokeStyle = PALETTE.orange; ctx.lineWidth = 14; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(cx - 60, cy + 10); ctx.quadraticCurveTo(cx, cy + 35, cx + 80, cy + 5); ctx.stroke();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 20, cy - 35, 45, 15, 0.4);
    }
  },

  // STAGE 82: スナップバック・キャップ
  82: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx - 30, cy, 100, Math.PI, 0); ctx.fill();
      ctx.fillRect(cx - 150, cy - 5, 260, 25);
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx - 30, cy - 100, 10, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.arc(cx - 30, cy, 100, Math.PI, 0); ctx.stroke();
        ctx.strokeRect(cx - 150, cy - 5, 260, 25);
        ctx.beginPath(); ctx.arc(cx - 30, cy - 100, 10, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 30, cy - 50, 200, 100, PALETTE.dark, 'cloth');
      ctx.beginPath(); ctx.arc(cx - 30, cy, 100, Math.PI, 0); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 20, cy + 7, 260, 25, PALETTE.crimson, 'cloth');
      ctx.fillRect(cx - 150, cy - 5, 260, 25);
      ctx.fillStyle = PALETTE.white;
      ctx.fillRect(cx - 55, cy - 65, 50, 40);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 55, cy - 65, 30, 20, 0.35);
    }
  },

  // STAGE 83: スケートボードデッキ
  83: (ctx, cx, cy, mode) => {
    const drawDeck = () => {
      ctx.beginPath(); ctx.roundRect(cx - 160, cy - 45, 320, 90, 45); ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawDeck(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawDeck(); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx - 160, cy); ctx.lineTo(cx + 160, cy);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 320, 90, PALETTE.cyan, 'lacquer');
      drawDeck(); ctx.fill();
      ctx.fillStyle = PALETTE.purple; ctx.fillRect(cx - 70, cy - 45, 140, 90);
      ctx.fillStyle = PALETTE.yellow;
      ctx.beginPath(); ctx.arc(cx, cy, 28, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 45, cy - 25, 45, 12, 0.6);
    }
  },

  // STAGE 84: スクエアサングラス
  84: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.fillRect(cx - 130, cy - 40, 260, 80);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.strokeRect(cx - 130, cy - 40, 260, 80);
        ctx.strokeRect(cx - 110, cy - 25, 90, 50);
        ctx.strokeRect(cx + 20, cy - 25, 90, 50);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 260, 80, PALETTE.darkWood, 'lacquer');
      ctx.fillRect(cx - 130, cy - 40, 260, 80);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 65, cy, 90, 50, PALETTE.coral, 'glass');
      ctx.fillRect(cx - 110, cy - 25, 90, 50);
      ctx.fillRect(cx + 20, cy - 25, 90, 50);
      ctx.fillStyle = PALETTE.gold;
      ctx.beginPath(); ctx.arc(cx - 120, cy - 30, 4, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 120, cy - 30, 4, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 65, cy - 10, 25, 15, 0.65);
      ShadingPipeline.renderSpecularGlint(ctx, cx + 65, cy - 10, 25, 15, 0.65);
    }
  },

  // STAGE 85: ストリートバックパック
  85: (ctx, cx, cy, mode) => {
    const drawBackpack = () => {
      ctx.beginPath(); ctx.roundRect(cx - 95, cy - 140, 190, 280, 50); ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBackpack(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.roundRect(cx - 75, cy + 10, 150, 100, 18); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBackpack(); ctx.stroke();
        ctx.beginPath(); ctx.roundRect(cx - 75, cy + 10, 150, 100, 18); ctx.stroke();
        ctx.strokeRect(cx - 20, cy - 90, 40, 20);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 190, 280, PALETTE.forest, 'cloth');
      drawBackpack(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 60, 150, 100, PALETTE.orange, 'cloth');
      ctx.beginPath(); ctx.roundRect(cx - 75, cy + 10, 150, 100, 18); ctx.fill();
      ctx.fillStyle = PALETTE.black;
      ctx.fillRect(cx - 20, cy - 90, 40, 20);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 65, 30, 30, 0.35);
    }
  },

  // STAGE 86: パイロット・クロノグラフ
  86: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.fillRect(cx - 40, cy - 180, 80, 360);
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy, 95, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy, 75, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.strokeRect(cx - 40, cy - 180, 80, 360);
        ctx.beginPath(); ctx.arc(cx, cy, 95, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, 75, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx + 95, cy - 12, 18, 24);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 80, 360, PALETTE.navy, 'leather');
      ctx.fillRect(cx - 40, cy - 180, 80, 360);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 190, 190, PALETTE.silver, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy, 95, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx, cy, 75, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.gold;
      ctx.beginPath(); ctx.arc(cx - 25, cy, 18, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 25, cy, 18, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 35, 35, 35, 0.65);
    }
  },

  // STAGE 87: DJヘッドホン
  87: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy - 20, 110, Math.PI, 0); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.ellipse(cx - 100, cy + 20, 30, 55, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx + 100, cy + 20, 30, 55, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.arc(cx, cy - 20, 110, Math.PI, 0); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx - 100, cy + 20, 30, 55, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx + 100, cy + 20, 30, 55, 0, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx, cy - 20, 110, Math.PI, 0); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 100, cy + 20, 60, 110, PALETTE.cyan, 'lacquer');
      ctx.beginPath(); ctx.ellipse(cx - 100, cy + 20, 30, 55, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx + 100, cy + 20, 30, 55, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.silver;
      ctx.beginPath(); ctx.arc(cx - 100, cy + 20, 12, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 100, cy + 20, 12, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 105, cy, 15, 25, 0.6);
      ShadingPipeline.renderSpecularGlint(ctx, cx + 95, cy, 15, 25, 0.6);
    }
  },

  // STAGE 88: 革ジャン・ライダース
  88: (ctx, cx, cy, mode) => {
    const drawJacket = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 140, cy - 100); ctx.lineTo(cx + 140, cy - 100); ctx.lineTo(cx + 100, cy + 150); ctx.lineTo(cx - 100, cy + 150); ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawJacket(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath();
      ctx.moveTo(cx, cy - 100); ctx.lineTo(cx - 70, cy - 20); ctx.lineTo(cx - 20, cy + 20); ctx.closePath(); ctx.fill();
      ctx.beginPath();
      ctx.moveTo(cx, cy - 100); ctx.lineTo(cx + 70, cy - 20); ctx.lineTo(cx + 20, cy + 20); ctx.closePath(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawJacket(); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(cx - 20, cy + 20); ctx.lineTo(cx + 40, cy + 150); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 280, 250, PALETTE.black, 'leather');
      drawJacket(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 40, 140, 120, PALETTE.crimson, 'leather');
      ctx.beginPath(); ctx.moveTo(cx, cy - 100); ctx.lineTo(cx - 70, cy - 20); ctx.lineTo(cx - 20, cy + 20); ctx.closePath(); ctx.fill();
      ctx.fillStyle = PALETTE.silver;
      ctx.beginPath(); ctx.moveTo(cx - 20, cy + 20); ctx.lineTo(cx + 40, cy + 150); ctx.stroke();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy - 40, 45, 20, 0.45);
    }
  },

  // STAGE 89: ワークブーツ
  89: (ctx, cx, cy, mode) => {
    const drawBoot = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 90, cy - 150);
      ctx.lineTo(cx - 10, cy - 150);
      ctx.lineTo(cx - 10, cy + 10);
      ctx.lineTo(cx + 100, cy + 30);
      ctx.lineTo(cx + 110, cy + 80);
      ctx.lineTo(cx - 90, cy + 80);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBoot(); ctx.fill();
      ctx.fillRect(cx - 95, cy + 80, 210, 30);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBoot(); ctx.stroke();
        ctx.strokeRect(cx - 95, cy + 80, 210, 30);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 35, 200, 230, PALETTE.wood, 'leather');
      drawBoot(); ctx.fill();
      ctx.fillStyle = PALETTE.black; ctx.fillRect(cx - 95, cy + 80, 210, 30);
      ctx.fillStyle = PALETTE.brass;
      for (let i = 0; i < 4; i++) {
        ctx.beginPath(); ctx.arc(cx - 20, cy - 120 + i * 35, 6, 0, Math.PI * 2); ctx.fill();
      }
      ShadingPipeline.renderSpecularGlint(ctx, cx + 45, cy + 35, 30, 15, 0.4);
    }
  },

  // STAGE 90: グラフィティ・スプレー缶
  90: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.roundRect(cx - 65, cy - 80, 130, 230, 14); ctx.fill();
      ctx.fillRect(cx - 50, cy - 140, 100, 55);
      ctx.fillRect(cx - 15, cy - 160, 30, 20);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.roundRect(cx - 65, cy - 80, 130, 230, 14); ctx.stroke();
        ctx.strokeRect(cx - 50, cy - 140, 100, 55);
        ctx.strokeRect(cx - 15, cy - 160, 30, 20);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 35, 130, 230, PALETTE.cyan, 'metallic');
      ctx.beginPath(); ctx.roundRect(cx - 65, cy - 80, 130, 230, 14); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 112, 100, 55, PALETTE.pink, 'lacquer');
      ctx.fillRect(cx - 50, cy - 140, 100, 55);
      ctx.fillStyle = PALETTE.silver;
      ctx.fillRect(cx - 15, cy - 160, 30, 20);
      ctx.fillRect(cx - 65, cy + 10, 130, 45);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy + 20, 15, 70, 0.65);
    }
  }
};
